import React, { useState } from 'react'
import { useQueryClient } from 'react-query'
import { toast } from 'sonner'
import { ChevronDown } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'
import { taskService } from '@/services/taskService'

const categoryColors = {
  done: 'bg-green-500',
  in_progress: 'bg-blue-500',
  todo: 'bg-slate-400',
}

const InlineStatusSelect = ({ task, statuses, projectId }) => {
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)
  const status = task.status

  const handleChange = async (newStatusId) => {
    setOpen(false)
    if (newStatusId === task.status_id) return
    try {
      await taskService.updateTask(projectId, task.id, { status_id: newStatusId })
      queryClient.invalidateQueries(['projects', String(projectId), 'tasks'])
      toast.success('Status updated')
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update status')
    }
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          onClick={(e) => { e.stopPropagation(); setOpen(true) }}
          className="group inline-flex items-center gap-1.5 text-sm hover:bg-accent rounded px-1.5 py-0.5 -mx-1.5 transition-colors"
        >
          <span className={cn('w-2 h-2 rounded-full shrink-0', categoryColors[status?.category] || 'bg-gray-400')} />
          {status?.name || '—'}
          <ChevronDown className="h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-44 p-1" align="start" onClick={(e) => e.stopPropagation()}>
        {statuses.map((s) => (
          <button
            key={s.id}
            onClick={() => handleChange(s.id)}
            className={cn(
              'w-full flex items-center gap-2 px-2 py-1.5 rounded text-sm hover:bg-accent transition-colors',
              s.id === task.status_id && 'bg-accent font-medium'
            )}
          >
            <span className={cn('w-2 h-2 rounded-full shrink-0', categoryColors[s.category] || 'bg-gray-400')} />
            {s.name}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  )
}

export default InlineStatusSelect
